import { render, staticRenderFns } from "./TitleHorizontalList.vue?vue&type=template&id=21298de5&scoped=true&"
import script from "./TitleHorizontalList.vue?vue&type=script&lang=js&"
export * from "./TitleHorizontalList.vue?vue&type=script&lang=js&"
import style0 from "./TitleHorizontalList.vue?vue&type=style&index=0&id=21298de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21298de5",
  null
  
)

export default component.exports